export class UserFacility 
{
        GroupNumber?: string;
        GroupName?: string;
        DivisionMasterID?: number;
        DivisionNumber?: string;
        DivisionName?: string;
        RegionMasterID?: number;
        RegionNumber?: string;
        RegionName?: string;
        FacilityMasterID?: number;
        FacilityNumber?: string;
        FacilityName: string;
        FacilityDisplayName: string;
        isActiveFlag: number;
}
export interface UserLocationFacility {
        DivisionMasterID: number;
        RegionMasterID: number;
        FacilityMasterID: number;
        FacilityNumber: string;
        FacilityName: string;
        FacilityDisplayName: string;
        LocationModality: string;
        IsHomeWorkFlow:boolean;
    }